export default class GridHeader {
  public ['class']: string | string[]
  constructor(
    public text: string,
    public value: string,
    public align: string = 'center',
    public sortable: boolean = true,
    public width: string | number = '',
    public extraClass: string | string[] = '',
  ) {
    this.class = extraClass
  }
}
